/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerGetBatchQueryResponse, TransferBatchesControllerGetBatchPathParams, TransferBatchesControllerGetBatch400, TransferBatchesControllerGetBatch401, TransferBatchesControllerGetBatch403, TransferBatchesControllerGetBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerGetBatch";

function getTransferBatchesControllerGetBatchUrl(id: TransferBatchesControllerGetBatchPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/transfer-batches/${id}` as const }  
  return res
}

/**
 * @summary Get a transfer batch by ID
 * {@link /api/v1/transfer-batches/:id}
 */
export async function transferBatchesControllerGetBatch(id: TransferBatchesControllerGetBatchPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferBatchesControllerGetBatchQueryResponse, ResponseErrorConfig<TransferBatchesControllerGetBatch400 | TransferBatchesControllerGetBatch401 | TransferBatchesControllerGetBatch403 | TransferBatchesControllerGetBatch404>, unknown>({ method : "GET", url : getTransferBatchesControllerGetBatchUrl(id).url.toString(), ... requestConfig })  
  return res.data
}